module.exports = __webpack_public_path__ + "img/mobile-banner2-en.5734db8d.jpg";